// 重大度バッジ(ドメイン非依存)。色 + テキストの両方で表す(WCAG2: 色のみに依存しない)。
// tone と並び順は全ドメイン共通だが、**表記はドメインの用語に従う**ため呼び出し側がラベルを渡す
// (Salesforce は critical =「重大」、Google Workspace は「致命的」)。
// 文言をここで統一するのはプロダクト判断であり、共有プリミティブが黙って決めてよい事柄ではない。
import { createBadge } from "./badge";
import type { Tone } from "./tokens";

export type SeverityLevel = "critical" | "high" | "medium" | "low";

// 表示・フィルタの並び(critical → low)。
export const SEVERITY_LEVELS: readonly SeverityLevel[] = ["critical", "high", "medium", "low"];

export const SEVERITY_TONE: Record<SeverityLevel, Tone> = {
  critical: "danger",
  high: "warning",
  medium: "info",
  low: "neutral",
};

export const SEVERITY_ORDER: Record<SeverityLevel, number> = {
  critical: 0,
  high: 1,
  medium: 2,
  low: 3,
};

export interface SeverityBadgeProps {
  readonly severity: SeverityLevel;
  readonly label: string;
}

export function createSeverityBadge(props: SeverityBadgeProps): HTMLElement {
  return createBadge({ label: props.label, tone: SEVERITY_TONE[props.severity] });
}
